import React, { ChangeEvent } from "react";
import { FormControlLabel, IconButton, Radio, Typography } from "@mui/material";
import { MdClose } from "@react-icons/all-files/md/MdClose";
import { SheetContainer } from "../../../styles/common";
import { IOption } from "../mobileDropdown/mobileDropdown";
import { DrawerBody, Group, Header, Note } from "./bottomSheet.styles";

export interface IBottomSheet {
  list: string[] | IOption[];
  note?: string;
  onClose?: () => void;
  onSelection?: (value: string) => void;
  open: boolean;
  selected: string | null;
  title: string | null;
}

function BottomSheet({
  note,
  list,
  onClose,
  onSelection,
  open,
  selected,
  title,
}: IBottomSheet) {
  const handleChange = (_: ChangeEvent<HTMLInputElement>, value: string) => {
    onSelection?.(value);
  };
  return (
    <SheetContainer open={open} onClose={onClose} anchor="bottom">
      <Header>
        <Typography variant="h6">{title}</Typography>
        <IconButton id="close" onClick={onClose}>
          <MdClose />
        </IconButton>
      </Header>
      <DrawerBody>
        <Group onChange={handleChange} value={selected}>
          {list.map((item) => (
            <FormControlLabel
              key={typeof item === "string" ? item : item.value}
              value={typeof item === "string" ? item : item.value}
              control={
                <Radio
                  disabled={typeof item === "string" ? false : !item.isEnabled}
                />
              }
              label={typeof item === "string" ? item : item.value}
            />
          ))}
        </Group>
        {note && <Note severity="info">{note}</Note>}
      </DrawerBody>
    </SheetContainer>
  );
}

export default BottomSheet;
